import { Component, Input, Output, EventEmitter } from '@angular/core';
import {  Router } from '@angular/router' ;
import { ApiService } from '../../../custom-material/Services/api.service';
import { UserModel } from '../../Models';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'main-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.less']
})
export class MenuComponent {

  links = [
    {
      route: '/',
      selectedRoutes: [''],
      color: 'lessaccent',
      showInSummary: false,
      minUserState: 0,
      icon: 'home',
      //label: 'ACCUEIL'
      label: 'menu-home'
    },
    {
      route: '/buildings',
      selectedRoutes: [
        'buildings',
        'questionnary',
        'report'
      ],
      color: 'basic',
      showInSummary: true,
      minUserState: 0,
      introTabIndex: 0,
      icon: 'location_city',
      //label: 'ETABLISSEMENTS \n& AUDITS'
      label: 'menu-audits'
    },
    {
      route: '/synthesis',
      selectedRoutes: ['synthesis'],
      color: 'special',
      showInSummary: true,
      minUserState: 1,
      introTabIndex: 1,
      icon: 'pie_chart',
      //label: 'SYNTHESE \nDES AUDITS'
      label: 'menu-synthesis'
    },
    {
      route: '/rm/objectifs',
      selectedRoutes: ['rm'],
      color: 'primary',
      showInSummary: true,
      minUserState: 1,
      introTabIndex: 2,
      icon: 'account_tree',  // 'multiline_chart',
      //label: 'MANAGEMENT \nDES RISQUES'
      label: 'menu-management'
    },
    {
      route: '/incidents',
      selectedRoutes: ['incidents'],
      color: 'danger',
      showInSummary: true,
      minUserState: 0,
      introTabIndex: 3,
      icon: 'sync_problem',
      //label: 'REMONTÉE \nD\'INCIDENTS'
      label: 'menu-incidents'
    },
    {
      route: '/statistiques',
      selectedRoutes: ['statistiques'],
      color: 'secondary',
      showInSummary: true,
      minUserState: 0,
      introTabIndex: 4,
      icon: 'show_chart',
      //label: 'STATISTIQUES \nMENSUELLES',
      label: 'menu-stats'
    },

  ];

  get filteredLinks(): Array<object>
  {
    const userState = this.apiService.connectedUser.state;
    return this.links.filter((link) => userState >= link.minUserState );
  }
  get selectedLink(): string
  {
    return this.router.url.split('/')[1];
  }

  @Output()
  change: EventEmitter<any> = new EventEmitter();


  @Output()
  changeOver: EventEmitter<number> = new EventEmitter();


  constructor(private router: Router,
              private apiService: ApiService
              ) { }

  onChange(link)
  {
    this.change.emit(link);
  }

  over(event, index)
  {
    this.changeOver.emit(index);
  }
}
